<template>
  <div>
    <img id="pdfLogo" src="../../assets/logos/booracolorido.png" alt="" />
    <div v-if="templatePlans">
      <div id="pdfTitle">Relatório de Utilização de Veículos</div>
      <div id="pdfGenerated">Gerado em {{ formatDate(dateNow()) }}</div>
      <div id="Content">
        <v-data-table
          :headers="PlansHeader"
          :items="itemList"
          hide-default-footer
          class="mytable elevation-1 mt-2"
          item-key="plate"
          id="trigger"
          sort-by="client"
          disable-pagination
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.plate }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.client }}</td>
              <td>{{ item.completed }}</td>
              <td>{{ item.hours }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    templatePlans: Boolean,
    itemList: Array,
  },
  created() {
    this.formatFilePdf();
  },
  data() {
    return {
      rowNumber: 0,
      PlansHeader: [
        { text: 'Placa', value: 'plate' },
        { text: 'Modelo', value: 'model' },
        { text: 'Cliente', value: 'client' },
        { text: 'Reservas Concluídas', value: 'completed' },
        { text: 'Horas Totais', value: 'hours' },
        { text: 'Valor Total', value: 'value' },
      ],
    };
  },

  methods: {
    async formatFilePdf() {
      let table = document.getElementsByTagName('TR');
      let n = table.length;

      for (let i = 0; i < n; i++) {
        table[i].click();
      }
    },

    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },

    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },

    pageBreak() {
      this.rowNumber += 1;

      if (this.rowNumber % 27) return true;

      return false;
    },
  },
};
</script>
<style>
#pdfLogo {
  width: 200px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

#pdfTitle {
  padding: 10px;
  font-weight: 600;
  font-size: 30px;
}

#pdfGenerated {
  padding: 10px;
}

#pdfStyle {
  width: 100%;
  text-align: left;
  position: absolute;
  top: 10px;
}

.mytable thead tr th {
  background-color: #993995 !important;
  color: #fff !important;
}

.mytable thead tr th i {
  color: #fff !important;
}

.v-data-table {
  word-break: normal;
}

.v-data-table {
  word-break: normal;
}

.flex-align {
  display: flex;
  justify-content: flex-start;
}

.VlistItem {
  display: flex;
  justify-content: flex-start;
  padding: 0;
}

.boldTitle {
  font-weight: 600;
}

.rowsMaintenance {
  padding: 0;
}
</style>
